import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DueAmtByDaysRes;
export const DueAmtByDaysTodo = createAsyncThunk('DueAmtByDays', async (data) => {


    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'dashboard_due_amount_by_days',
            headers: { "Content-Type": "application/json" },
            data:
            {
                "vcustomer_code": localStorage.getItem('vcust_plant_code'),
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
                "days": "45"
            }
        })
        return DueAmtByDaysRes = res.data

    } catch (error) {
        return DueAmtByDaysRes = error.response.data
    }
});

const DueAmtByDaysSlice = createSlice({
    name: 'DueAmtByDays',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(DueAmtByDaysTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(DueAmtByDaysTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default DueAmtByDaysSlice.reducer; 